import React, { useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import TableTemplate from "@components/Table/TableTemplate";
import { BOOKS_ENDPOINT } from "@constants/Endpoints";
import { bookNumberMask } from "@helpers/utils/utils";

import "./PreregistrationBooks.scss";

export function PreregistrationBooks() {
    const tableTemplateRef = useRef(null);
    const [t] = useTranslation();

    const [columns] = useState([
        {
            name: "isbn",
            headerCaption: t("ISBN"),
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "title",
            headerCaption: t("Title"),
            size: "big",
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "bookNumber",
            headerCaption: t("BookNumber"),
            caption: (x) => bookNumberMask(x.bookNumber),
            filterPattern: /^(\d+\.?)+$/,
            filterParser: (x) => x.replace(/\./g, ""),
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
    ]);

    // @ts-ignore
    return (
        <div className="book-overview-page">
            <TableTemplate
                ref={tableTemplateRef}
                // @ts-ignore
                title={t("Books")}
                endpoint={BOOKS_ENDPOINT}
                columns={columns}
                uniqueId="isbn"
                paginator={true}
            />
        </div>
    );
}
